// eslint-disable-next-line no-undef
export const BASE_URL = process.env.REACT_APP_API_URL;
export const ENV = process.env.REACT_APP_ENV;
